
export class MessageType {

  public static SEND_BANANA_FUN_MESSAGES = [
    `In the beginning, there was one banana... and it was good. 🍌 Banana it forward.`,
    `We choose to toss this banana, not because it is easy, but because it is fun. 🚀 Banana it forward.`,
    `Ask not what your banana can do for you - ask what you can do for the Bananaverse. 🍌 Banana it forward.`,
    `One small step for banana. One giant leap for the Bananaverse - Banana it forward.`,
    
    `The peel heard 'round the world. 🍌 Banana it forward.`,
    `Four score and seven peels ago, the Bananaverse was born. 🍌 Banana it forward.`,
    `Give me bananas, or give me death! 🍌 Banana it forward.`,
    `Float like a banana, sting like a peel. 🍌 Banana it forward.`,
    `May the peel be with you. 🍌 Banana it forward.`,
    `I'm gonna make you a banana you can't refuse. 🍌 Banana it forward.`,
    `Nobody puts banana in a corner. 🍌 Banana it forward.`,
    `Here's looking at you, banana. 🍌 Banana it forward.`,
    `Say hello to my little banana. 🍌 Banana it forward.`,
    `You can't handle the banana! 🍌 Banana it forward.`,
  
    `When life gives you bananas, banana it forward.`,
    `You can't buy happiness, but you can toss a banana. 🍌 Banana it forward.`,
    `A banana in the hand is worth two in the bunch. 🍌 Banana it forward.`,
    `The early banana catches the smile. 🍌 Banana it forward.`,
    `Where there's a banana, there's a way. 🍌 Banana it forward.`,
    `A rolling banana gathers no moss. 🍌 Banana it forward.`,
  
    `The journey of a thousand bananas begins with a single toss. 🍌 Banana it forward.`,
    `Banana boldly, live fully. 🍌 Banana it forward.`,
    `Toss your banana like the world is watching. 🍌 Banana it forward.`,
    `Believe in your peel power. 🍌 Banana it forward.`,
    `Every great chain starts with a single banana. 🍌 Banana it forward.`,
    `This banana changes everything - starting now. 🍌 Banana it forward.`,
    `Make your toss the one they'll remember. 🍌 Banana it forward.`,
    `Bananas don't wait for perfect moments - they make them. 🍌 Banana it forward.`,
  
    `Banana #1 is legally a wizard now. 🍌 Banana it forward.`,
    `This banana contains 1% mystery and 99% potassium. 🍌 Banana it forward.`,
    `Do not taunt Banana #1 - it can hear you. 🍌 Banana it forward.`,
    `This banana is trending in exactly three parallel universes. 🍌 Banana it forward.`,
    `Warning: tossing this banana may cause uncontrollable joy. 🍌 Banana it forward.`,
    `This banana is now the rightful ruler of all sandwiches. 🍌 Banana it forward.`,
    `You are now part of this banana's origin story. 🍌 Banana it forward.`,
    `This banana knows what you did last snack time. 🍌 Banana it forward.`,
  ]
}